module.exports = __webpack_public_path__ + "img/rotaryfoundation.b47b669.png";